import { Component, computed } from '@angular/core';

// Components
import { TopbarUserMenu } from './user-menu/user-menu';

// Services
import { MainViewService } from '@core/services/main-view.service';
import { ModuleService } from '@core/services/module.service';
import { SessionService } from '@core/services/session.service';
import { SidebarService } from '@core/services/layouts/sidebar.service';
import { TopbarService } from '@core/services/layouts/topbar.service';

// Utils
import { Dic } from '@core/utils/dic.utils';

// PrimeNG
import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';

/**
 * Barre supérieure — libellé de la vue courante, actions (cotisation, visio) et
 * déclencheur du menu profil, dont le contenu vit dans `TopbarUserMenu`.
 */
@Component({
	selector: 'layout-topbar',
	imports: [TopbarUserMenu, PopoverModule, TooltipModule],
	templateUrl: './topbar.html',
	styleUrl: './topbar.scss',
})
export class TopbarLayout {
	protected readonly Dic = Dic;

	constructor(
		public sidebar: SidebarService,
		private session: SessionService,
		private module: ModuleService,
		private mainView: MainViewService,
		private topbarService: TopbarService,
	) {
		topbarService.load();
	}

	readonly showVideoCall = computed(() => !!this.session.data()?.devmode);

	readonly displayName = computed(() => this.session.fullName() || '');
	readonly isMember = computed(() => this.session.isMember());
	readonly hasCotisation = computed(() => this.topbarService.hasXType('club-cotisation'));

	readonly subtitle = computed(() => {
		const data = this.session.data();
		return data?.displayevent || data?.mandant || '';
	});

	readonly crumb = computed(() => this.mainView.viewItem()?.text ?? '');

	readonly userInitials = computed(() => {
		const parts = this.displayName().trim().split(/\s+/).filter(Boolean);
		if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
		if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
		return '?';
	});

	openModule(xtype: string): void {
		this.module.openModule(xtype);
	}
}
